<template>
    <div :class="cx('root')" :style="sx('root')" v-bind="ptmi('root')">
        <canvas ref="canvas" :width="width" :height="height" @click="onCanvasClick($event)" v-bind="{ ...canvasProps, ...ptm('canvas') }"></canvas>
    </div>
</template>

<script>
import Chart from 'primevue/chart';

/**
 * Chart com proteção contra erro "can't acquire context from the given item"
 * ao sair da página. Verifica se o canvas ainda existe antes de inicializar.
 */
export default {
    name: 'SafeChart',
    extends: Chart,
    methods: {
        initChart() {
            import('chart.js/auto').then((module) => {
                if (!this.$refs?.canvas) return;

                if (this.chart) {
                    this.chart.destroy();
                    this.chart = null;
                }

                if (module?.default) {
                    this.chart = new module.default(this.$refs.canvas, {
                        type: this.type,
                        data: this.data,
                        options: this.options,
                        plugins: this.plugins
                    });
                }

                this.$emit('loaded', this.chart);
            });
        }
    }
};
</script>
